import React, { useState, useCallback } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE =
  "حساب الطاقة الكهربائية - احسب الطاقة الكهربائية، القدرة، أو الوقت";
const DESCRIPTION =
  "حاسبة الطاقة الكهربائية الشامل: قم بحساب الطاقة الكهربائية، القدرة، أو الوقت بناءً على القيم المدخلة للقدرة، أو الوقت، أو الطاقة الكهربائية. أداة دقيقة وسهلة الاستخدام.";
const KEYWORDS =
  "طاقة كهربائية, حساب الطاقة الكهربائية, حاسبة الطاقة الكهربائية, حساب القدرة, حساب الوقت, كهرباء";
const OG_URL = "https://do-calculate.com/calculator/ar/electricalenergy";
function ElectricalEnergyCalculator() {
  const [power, setPower] = useState("");
  const [time, setTime] = useState("");
  const [energy, setEnergy] = useState("");
  const [calculationMode, setCalculationMode] = useState("calculateEnergy");
  const [error, setError] = useState("");
  const [showSteps, setShowSteps] = useState(false);
  const updateCalculations = useCallback(() => {
    setError("");
    const powerValue = parseFloat(power) || 0;
    const timeValue = parseFloat(time) || 0;
    const energyValue = parseFloat(energy) || 0;
    switch (calculationMode) {
      case "calculateEnergy":
        if (powerValue > 0 && timeValue > 0) {
          const calculatedEnergy = powerValue * timeValue;
          setEnergy(Math.round(calculatedEnergy * 100) / 100);
        } else {
          setError("الرجاء إدخال القدرة والوقت بشكل صحيح");
        }
        break;
      case "calculatePower":
        if (energyValue > 0 && timeValue > 0) {
          const calculatedPower = energyValue / timeValue;
          setPower(Math.round(calculatedPower * 100) / 100);
        } else {
          setError("الرجاء إدخال الطاقة والوقت بشكل صحيح");
        }
        break;
      case "calculateTime":
        if (energyValue > 0 && powerValue > 0) {
          const calculatedTime = energyValue / powerValue;
          setTime(Math.round(calculatedTime * 100) / 100);
        } else {
          setError("الرجاء إدخال الطاقة والقدرة بشكل صحيح");
        }
        break;
      default:
        break;
    }
  }, [power, time, energy, calculationMode]);
  const handleCalculateClick = () => {
    updateCalculations();
    setShowSteps(true);
  };
  const handlePowerChange = (e) => setPower(e.target.value);
  const handleTimeChange = (e) => setTime(e.target.value);
  const handleEnergyChange = (e) => setEnergy(e.target.value);
  const handleModeChange = (e) => setCalculationMode(e.target.value);
  const getSolutionSteps = () => {
    switch (calculationMode) {
      case "calculateEnergy":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب الطاقة الكهربائية:</h4>
            <ol>
              <li>ادخل القدرة (بالواط) في الحقل المخصص.</li>
              <li>ادخل الوقت (بـ الثواني) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على الطاقة الكهربائية.</li>
              <li>الطاقة الكهربائية تساوي القدرة × الوقت.</li>
            </ol>
          </div>
        );
      case "calculatePower":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب القدرة:</h4>
            <ol>
              <li>ادخل الطاقة الكهربائية (بالجول) في الحقل المخصص.</li>
              <li>ادخل الوقت (بـ الثواني) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على القدرة.</li>
              <li>القدرة تساوي الطاقة الكهربائية / الوقت.</li>
            </ol>
          </div>
        );
      case "calculateTime":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب الوقت:</h4>
            <ol>
              <li>ادخل الطاقة الكهربائية (بالجول) في الحقل المخصص.</li>
              <li>ادخل القدرة (بالواط) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على الوقت.</li>
              <li>الوقت يساوي الطاقة الكهربائية / القدرة.</li>
            </ol>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تتيح لك حاسبة الطاقة الكهربائية إجراء ثلاث أنواع من الحسابات
                  استنادًا إلى القيم المدخلة. اختر نوع الحساب المناسب لك وأدخل
                  القيم المتوفرة لحساب القيمة المفقودة بدقة وسهولة.
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد الطاقة الكهربائية بمعلومية القدرة والوقت
                </h2>
                <p>
                  إذا كنت تعرف القدرة (بـ الواط) والوقت (بـ ثواني)، يمكنك حساب
                  الطاقة الكهربائية (بـ الجول) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>الطاقة الكهربائية = القدرة × الوقت</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد القدرة بمعلومية الطاقة الكهربائية والوقت
                </h2>
                <p>
                  إذا كنت تعرف الطاقة الكهربائية (بـ الجول) والوقت (بـ ثواني)،
                  يمكنك حساب القدرة (بـ الواط) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>القدرة = الطاقة الكهربائية / الوقت</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد الوقت بمعلومية الطاقة الكهربائية والقدرة
                </h2>
                <p>
                  إذا كنت تعرف الطاقة الكهربائية (بـ الجول) والقدرة (بـ الواط)،
                  يمكنك حساب الوقت (بـ ثواني) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>الوقت = الطاقة الكهربائية / القدرة</b>
                </p>
                <p>
                  استخدم هذه الأداة لإدخال القيم المتاحة وحساب القيمة المفقودة
                  بدقة، مما يسهل عليك إجراء الحسابات المتعلقة بالطاقة
                  الكهربائية.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group align-items-center">
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="calculationMode"
                      >
                        اختر نوع الحساب
                      </label>
                    </b>
                    <div id="calculationMode">
                      <br />
                      <div>
                        <input
                          type="radio"
                          id="calculateEnergy"
                          name="calculationMode"
                          value="calculateEnergy"
                          checked={calculationMode === "calculateEnergy"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateEnergy" className="ms-2">
                          حساب الطاقة الكهربائية
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculatePower"
                          name="calculationMode"
                          value="calculatePower"
                          checked={calculationMode === "calculatePower"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculatePower" className="ms-2">
                          حساب القدرة
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateTime"
                          name="calculationMode"
                          value="calculateTime"
                          checked={calculationMode === "calculateTime"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateTime" className="ms-2">
                          حساب الوقت
                        </label>
                      </div>
                    </div>
                  </div>
                  <br />
                  {calculationMode !== "calculatePower" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="powerInput">
                          القدرة (واط)
                        </label>
                      </b>
                      <input
                        id="powerInput"
                        type="number"
                        placeholder="1000"
                        value={power}
                        onChange={handlePowerChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateTime" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="timeInput">
                          الوقت (ثانية)
                        </label>
                      </b>
                      <input
                        id="timeInput"
                        type="number"
                        placeholder="3600"
                        value={time}
                        onChange={handleTimeChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateEnergy" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="energyInput"
                        >
                          الطاقة الكهربائية (جول)
                        </label>
                      </b>
                      <input
                        id="energyInput"
                        type="number"
                        placeholder="3600000"
                        value={energy}
                        onChange={handleEnergyChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculateClick}
                  >
                    احسب                  </button>
                  <br/>                  <div>
                    { (
                      <>
                        {error !== "" && (
                          <p className="p-3 mb-2 bg-warning text-white">
                            خطأ: {error}
                          </p>
                        )}
                        {calculationMode === "calculateEnergy" &&
                          energy !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              الطاقة الكهربائية (جول): {energy} جول
                            </p>
                          )}
                        {calculationMode === "calculatePower" &&
                          power !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              القدرة (واط): {power} واط
                            </p>
                          )}
                        {calculationMode === "calculateTime" && time !== "" && (
                          <p className="p-3 mb-2 bg-success text-white">
                            الوقت (ثانية): {time} ثانية
                          </p>
                        )}
                        {showSteps && getSolutionSteps()}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default ElectricalEnergyCalculator;
